export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14445.81d53403.jpg";